import {
  COMPLETED_GOAL,
  FAVOURITE_GOAL,
  IN_PROGRESS_GOAL,
} from "../../../utils/constants";
import { IGoal } from "../types";

export const filterGoals = ({
  goals,
  filterBy,
}: {
  goals: IGoal[];
  filterBy: string;
}) => {
  if (filterBy === FAVOURITE_GOAL) {
    return goals.filter((goal: IGoal) => goal.favourite);
  }

  if (filterBy === COMPLETED_GOAL) {
    return goals.filter((goal: IGoal) => goal.completed);
  }

  if (filterBy === IN_PROGRESS_GOAL) {
    return goals.filter((goal: IGoal) => goal.completed !== true);
  }
};
